import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IConfiguracionDocumentoCreateModel } from 'src/app/models/interfaces/configuracion-documento/IConfiguracionDocumentoCreateModel';
import { IConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IConfiguracionDocumentoModel';
import { IConfiguracionDocumentoUpdateModel } from 'src/app/models/interfaces/configuracion-documento/IConfiguracionDocumentoUpdateModel';
import { IFilterConfiguracionDocumentoModel } from 'src/app/models/interfaces/configuracion-documento/IFilterConfiguracionDocumentoModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionDocumentoService {
  private configUrl = [
    environment.apiGatewayUrl,
    'configuracion-documentos',
  ].join('/');
  
  constructor(
    private http: HttpClient
  ) { 
  }

  getListPaged(
    model: IFilterConfiguracionDocumentoModel
  ): Observable<SearchResultModel<IConfiguracionDocumentoModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    queryParams.push(`idEstado=${model.idEstado}`);

    queryParams.push(`idTipoVisita=${model.idTipoVisita}`);

    if(model.esPredeterminado){
      queryParams.push(`espredeterminado=${model.esPredeterminado}`);
    }


    return this.http.get<SearchResultModel<IConfiguracionDocumentoModel[]>>(
      this.configUrl + '?'+ queryParams.join('&')
    );
  }

  getList(
    model: IFilterConfiguracionDocumentoModel
  ): Observable<IConfiguracionDocumentoModel[]> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`idEstado=${model.idEstado}`);
    
    if(model.idSeccion)
      queryParams.push(`idSeccion=${model.idSeccion}`);
    
    queryParams.push(`idTipoVisita=${model.idTipoVisita}`);

    // if(model.esPredeterminado){
    //   queryParams.push(`espredeterminado=${model.esPredeterminado}`);
    // }

    return this.http.get<IConfiguracionDocumentoModel[]>(
      `${this.configUrl}/all/?${queryParams.join('&')}`
    );
  }

  getById(id: number): Observable<IConfiguracionDocumentoModel> {
    return this.http.get<IConfiguracionDocumentoModel>(`${this.configUrl}/${id}`);
  }

  submit(model: IConfiguracionDocumentoCreateModel) {
    return this.http.post<IConfiguracionDocumentoModel>(`${this.configUrl}`, model);
  }

  update(model: IConfiguracionDocumentoUpdateModel) {
    return this.http.put<IConfiguracionDocumentoModel>(
      `${this.configUrl}/${model.idConfiguracionDocumento}`,
      model
    );
  }
}
